import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Breadcrumb from "../components/Breadcrumb";
import StockOutService from "../services/StockOutService";

export default function ViewStockOutDetails() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, [id]);

  const loadData = async () => {
    try {
      setLoading(true);
      const res = await StockOutService.getById(id);
      const payload = res?.data?.data || res?.data || {};
      const details = payload.details || (Array.isArray(payload) ? payload : []);

      const formatted = details.map((d) => ({
        itemCategory: d.itemCategoryName || d.categoryName || d.itemCategory || "-",
        item: d.itemCode || d.itemName || d.itemId || "-",
        uom: d.UOM || d.UOMName || "-",
        quantity: d.quantity ?? 0,
        notes: d.notes || "-",
      }));

      setRows(formatted);
    } catch (err) {
      console.error("Error loading StockOut details:", err);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Breadcrumb pageTitle="Stock Out Details" secondTitle="Inventory" />

      <button
        type="button"
        className="btn btn-secondary"
        style={{ margin: "10px" }}
        onClick={() => navigate(-1)}
      >
        ← Back
      </button>

      <div className="card p-3 bg-white shadow-sm">
        <h4>Item Details</h4>
        {loading ? (
          <div className="text-center py-4">Loading...</div>
        ) : (
          <div className="table-responsive">
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Item Category</th>
                  <th>Item</th>
                  <th>UOM</th>
                  <th>Quantity</th>
                </tr>
              </thead>

              <tbody>
                {rows.length > 0 ? (
                  rows.map((r, idx) => (
                    <tr key={idx}>
                      <td>{r.itemCategory}</td>
                      <td><span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>{r.item}</span></td>
                      <td>{r.uom}</td>
                      <td><span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>{r.quantity}</span></td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center">
                      No records found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
}
